export default __webpack_public_path__ + "static/media/genhaven-white.b02d3baa.webp";